// import { styled } from '@mui/material/styles';
import Button from "@mui/material/Button";
import styled from "styled-components";

const StyledButton = styled(Button)({
  "&.MuiButton-root": {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 16,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "var(--theme-background)",
    borderRadius: "4px",
    borderColor: "var(--theme-background)",
    fontFamily: "latobold",
  },
  "&.MuiButton-root:hover": {
    opacity: "0.9",
    backgroundColor: "var(--theme-background)",
  },
  "&.MuiButton-root:active": {
    opacity: "0.9",
    backgroundColor: "var(--theme-background)",
  },
  // '&:focus': {
  //   boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
  // },
});

export { StyledButton };
